import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import * as serviceWorker from './serviceWorker';
import './index.css';

// WP-plugin deploy injects `gild-backoffice-root` into the WP page; the
// standalone SST subdomain deploy uses CRA's `public/index.html` which has
// `root`. Try the WP id first so embedded behavior is unchanged, then fall
// back to `root` for standalone + local dev.
const wpRoot = document.getElementById('gild-backoffice-root')
const target = wpRoot || document.getElementById('root');

// react-admin v3's <Admin> uses a hash router — on the standalone subdomain
// deploy too (no history prop is passed). The previous shim here rewrote hash
// URLs into BrowserRouter-style paths, which broke every emailed/bookmarked
// deep link: the hash router saw no hash and booted at the dashboard. Do the
// opposite: fold a path-style URL (from the old rewrite, or a hand-typed
// link) back into hash form. Guarded on the absence of the WP-injected div —
// the WP-plugin context serves under /backoffice/ and must not be rewritten.
if (!wpRoot && !window.location.hash.startsWith('#/') && window.location.pathname !== '/') {
  const { pathname, search } = window.location
  window.history.replaceState(null, '', `/${search}#${pathname}`)
}

if (target) {
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    target
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
